import * as React from 'react';

import { Button, ButtonTheme } from '@cian/button-component';
import { mergeStyles } from '@cian/utils';

import * as styles from './PhoneButton.css';

export interface IPhoneButtonProps {
  text: React.ReactNode;
  isSimplified: boolean;
  onPhoneOpened(): void;
}

export function PhoneButton({ text = 'Показать телефон', isSimplified, onPhoneOpened }: IPhoneButtonProps) {
  return (
    <Button
      {...mergeStyles(
        styles['button'],
        isSimplified && styles['simplified-button'],
      )}
      textClassName={`${styles['btn-text']}`}
      theme={ButtonTheme.Default}
      onClick={onPhoneOpened}
    >
      {text}
    </Button>
  );
}
